import { getLocale } from "../runtime";

const sv_iconcheckcomplete = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Slutförd`
};

const iconcheckcomplete = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_iconcheckcomplete(inputs)
	return "iconCheckComplete";
};

export { iconcheckcomplete as "iconCheckComplete" };